module.exports = __webpack_public_path__ + "img/Nigeria.539c6d11.jpg";